import React from "react";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { NavLink } from "react-router-dom";
import { WORK_RECORD_AND_TASKS_URL } from "../urls";

export const styles = {
  display: "block",
  height: "38px",
  width: "38px",
  cursor: "pointer",
  padding: "6px",
};

type Props = {
  workRecordID: string;
  forceNewTab?: boolean;
} & React.ComponentPropsWithRef<"a">;

/** Icon-button to a work record and tasks page. (NavLink with ref) */
export const ButtonViewTask = React.forwardRef<HTMLAnchorElement, Props>(
  (props, ref) => {
    const { workRecordID, forceNewTab, ...rest } = props;
    return (
      <NavLink
        to={`${WORK_RECORD_AND_TASKS_URL}/${workRecordID}`}
        target={forceNewTab ? "_blank" : undefined}
        ref={ref}
        {...rest}
        className="rounded-full text-gray-700 hover:bg-primaryOpacity90"
      >
        <FormatListBulletedIcon aria-label="view job button" style={styles} />
      </NavLink>
    );
  },
);
